import { render, staticRenderFns } from "./Notifications_Configuration.vue?vue&type=template&id=fad838ce&scoped=true&"
import script from "./Notifications_Configuration.vue?vue&type=script&lang=js&"
export * from "./Notifications_Configuration.vue?vue&type=script&lang=js&"
import style0 from "./Notifications_Configuration.vue?vue&type=style&index=0&id=fad838ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad838ce",
  null
  
)

export default component.exports